module.exports = __webpack_public_path__ + "static/img/about_company_banner_mobile_cn.782451ef.jpg";